import { Link } from "react-router-dom";
import { Scale, X, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";

export function CompareBar() {
  const { compare, toggleCompare, clearCompare } = useApp();
  if (compare.length === 0) return null;
  return (
    <div data-testid="compare-properties-bar" className="fixed bottom-16 lg:bottom-5 inset-x-0 z-40 px-3 pointer-events-none">
      <div className="max-w-4xl mx-auto bg-white border border-pbs-line rounded-2xl shadow-[0_12px_40px_rgba(35,107,69,0.18)] p-3 flex items-center gap-3 pointer-events-auto">
        <div className="hidden sm:flex items-center gap-2 pl-1 pr-2 border-r border-pbs-line">
          <Scale size={20} className="text-pbs-purple" />
          <span className="font-bold text-pbs-dark text-sm">Compare<br /><span className="text-pbs-grey font-semibold">{compare.length}/4</span></span>
        </div>
        <div className="flex-1 flex gap-2 overflow-x-auto no-scrollbar">
          {compare.map((p) => (
            <div key={p.slug} className="relative shrink-0 w-24">
              <img src={p.image} alt={p.name} className="w-24 h-16 object-cover rounded-lg" />
              <button onClick={() => toggleCompare(p)} className="absolute -top-1.5 -right-1.5 bg-pbs-coral text-white rounded-full w-5 h-5 flex items-center justify-center shadow">
                <X size={12} />
              </button>
              <p className="text-[10px] text-pbs-grey line-clamp-1 mt-0.5">{p.name}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-1.5 shrink-0">
          <Link to="/compare" data-testid="compare-now-btn"
            className="flex items-center gap-1.5 px-4 py-2.5 rounded-lg pbs-gradient text-white font-bold text-sm whitespace-nowrap">
            Compare <ArrowRight size={15} />
          </Link>
          <button onClick={clearCompare} className="text-[11px] text-pbs-grey hover:text-pbs-coral font-semibold">Clear all</button>
        </div>
      </div>
    </div>
  );
}

export default CompareBar;
